import { UserSettingRaw, UserSettingValueRaw } from 'src/types';

export type UserSettingValue = Pick<
  UserSettingValueRaw,
  'id' | 'value' | 'valueType' | 'userSettingId' | 'partnerId'
>;

export type UserSetting = Pick<UserSettingRaw, 'id' | 'name'> & {
  userSettingValues: UserSettingValue[];
};

export enum TimeFormats {
  Auto = 'auto',
  TwentyFourHour = '24_hour',
  TwelveHour = '12_hour',
}

export enum RecordOpenMode {
  SidePeek = 'side_peek',
  FullPage = 'full_page',
}

export enum UserSettingId {
  HiddenRecordFolders = 'hidden_record_folders',
  TimeFormatPreference = 'time_format_preference',
  AiSummaryVisibility = 'ai_summary_visibility',
  ComposerStartFolded = 'composer_start_folded',
  RecordOpenMode = 'record_open_mode',
  AssistantDockingPreference = 'assistant_docking_preference',
  FavoriteMacros = 'favorite_macros',
  ConversationSidePanelProfiles = 'conversation_side_panel_profiles',
  ConversationSidePanelPersonalization = 'conversation_side_panel_personalization',
  ConversationSidePanelGroupProfile = 'conversation_side_panel_group_profile',
  ClientSidePanelProfiles = 'client_side_panel_profiles',
  ClientSidePanelPersonalization = 'client_side_panel_personalization',
  ClientSidePanelGroupProfile = 'client_side_panel_group_profile',
  SiteSidePanelProfiles = 'site_side_panel_profiles',
  SiteSidePanelPersonalization = 'site_side_panel_personalization',
  SiteSidePanelGroupProfile = 'site_side_panel_group_profile',
}

// mapped local/fe types
export type UserSettingValueMap = Map<
  string,
  {
    value: UserSettingMappedValue;
    userSettingValue: UserSettingValue;
  }
>;

export type UserSettingMappedValue = string | number | boolean | string[] | number[] | null;
